import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '实体关系',
    type: 'BDRULE_DE',
}
